var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlexArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9969 0L0.993271 6.92435H3.38005C3.45704 7.86975 3.61103 8.81514 3.86767 9.73498C4.12431 10.6548 4.45795 11.5236 4.89424 12.3667C5.30487 13.2099 5.81815 14.002 6.38277 14.7174C6.94738 15.4329 7.58898 16.0972 8.28192 16.7104C8.97485 17.2981 9.71912 17.8347 10.5147 18.2691C11.3103 18.7034 12.1316 19.0611 12.9528 19.3422C13.7997 19.6233 14.6467 19.8021 15.5192 19.9043C16.3918 20.0065 17.2644 20.0321 18.1113 19.9554C17.2644 19.8788 16.4175 19.7255 15.5962 19.4955C14.775 19.2655 14.005 18.9589 13.2608 18.5757C12.5165 18.1924 11.8236 17.758 11.182 17.247C10.5404 16.736 9.9501 16.1739 9.43681 15.5606C8.92352 14.9474 8.46157 14.2831 8.07661 13.5932C7.69164 12.9033 7.38367 12.1879 7.15269 11.4469C6.92171 10.7059 6.76773 9.93939 6.69074 9.19841C6.61374 8.43187 6.61374 7.69089 6.66507 6.92435H9.02618L4.9969 0Z",
    fill: "#94CEBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexArrow);
export default __webpack_public_path__ + "static/media/flex-arrow.36414864620b11bb4e1dc1e1d1b06a61.svg";
export { ForwardRef as ReactComponent };